export default (() => {
    window.addEventListener('load', () => {
        // if (document.documentElement.dataset.accordionsActive) {
        //   return;
        // }
        // document.documentElement.dataset.accordionsActive = true;

        document.addEventListener('click', (event) => {
            const toggle = event.target.closest('[data-accordion-toggle]');
            if (toggle) {
                const options = toggle.dataset.accordionToggle && JSON.parse(toggle.dataset.accordionToggle);

                const accordion = toggle.closest('[data-accordion]');
                if (accordion) {
                    const items = accordion.querySelectorAll('[data-accordion-item]');
                    Array.from(items).forEach(item => {
                        const body = item.querySelector('[data-accordion-body]');
                        if (body && !body.style.height) {
                            body.style.height = item.classList.contains('is-collapsed') ? 0 : body.scrollHeight;
                        }

                        if (!item.contains(event.target)) {
                            item.classList.add('is-collapsed');
                            item.querySelector('[data-accordion-body]').style.height = 0;
                        }
                    });
                }

                const parent = toggle && toggle.parentElement;
                const body = parent && parent.querySelector('[data-accordion-body]');
                if (body) {
                    parent.classList.toggle('is-collapsed');
                    body.style.height = parent.classList.contains('is-collapsed') ? 0 : `${body.scrollHeight}px`;

                    // console.log('BODY', body, parent, parent.classList.contains('is-collapsed'), body.scrollHeight);
                    // body.toggleAttribute('hidden');
                }
            }
        });
    });
})();
